import React from 'react';
import { TypedMemo } from '../../common/types';
import { SMLAuthViewRenderer } from './SMLAuthViewRenderer';

const SMLAuthViewComponent: React.FC = () => {
  return <SMLAuthViewRenderer />;
};

export const SMLAuthView = TypedMemo(SMLAuthViewComponent);
